import featureFlagConstants from '~/common/helpers/featureFlagConstants';
import useFeatureFlag from '~/common/hooks/useFeatureFlag';

/**
 * Gates the HeroUI rewrite of the deployment details sidesheet.
 *
 * Off — the default while the flag is not rolled out — keeps the beehive
 * `DetailsDeploymentWithServerless` rendering exactly as it does today, so the migration can be
 * turned off from Split without a deploy.
 */
export const useDeploymentDetailsDrawerEnabled = () => {
  const { RUN_DEPLOYMENT_DETAILS_HEROUI } = featureFlagConstants;

  const { treatments, isReady } = useFeatureFlag([
    RUN_DEPLOYMENT_DETAILS_HEROUI
  ]);

  return {
    isEnabled: treatments[RUN_DEPLOYMENT_DETAILS_HEROUI]?.treatment === 'on',
    isReady
  };
};

export default useDeploymentDetailsDrawerEnabled;
